import React, { useState, useEffect } from "react";
import HeaderAdmin from "../../src/Components/HeaderAdmin/Header";
import BuildAccordion from "../DashboardPages/BuildSheet/BuildAccordion";
import { getbuildsheet, getbuildsheetdata } from "../Api/buildsheetApi"
import { useParams } from "react-router-dom";
import Loader2 from "../DashboardPages/DashboardComponents/Loader/Loader2";
import Spinner from 'react-bootstrap/Spinner';
import { getsinglebuildStations, upatebuildStationbuilderSatgeStatus } from "../Api/Buildstationsapi"
import { getallModeldatabymake } from "../Api/inventoryApi";
import { IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import { IoCloseSharp } from "react-icons/io5";
import BuildsheetInsights from "../DashboardPages/BuildSheet/BuildsheetInsights";
import { getremoteInquirydataApi } from "../Api/iron"
import { ShippingStGet } from '../Api/ShippingSt';
import { pickUpdownfilter, dropdownfilter } from '../Api/Buildstationsapi'
import { upatebuildStationStatus, assignpickupstation } from "../Api/Buildstationsapi"
import { getCurrentUser } from "../Api/auth";


function BuilderProjectView() {


    const params = useParams();
    const id = params.id;
    const [isLoading, setIsLoading] = useState(false);

    const history = useHistory();

    const [showinsight, setShowinsight] = useState(false);
    const [deliveryType, setDeliveryType] = useState(0);
    const [userdata, setUserdata] = useState('');

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Assigned');
    const [selectedOptionsId, setselectedOptionsId] = useState('');
    const [selectedOptionsIdFromBd, setselectedOptionsIdFromBd] = useState('');
    const [buildsheetdata, setBuildSheetData] = useState([]);
    const [buildApiCall, setBuildApiCall] = useState(0);
    const [buildsheetnumber, setBuildSheetNumber] = useState(0);
    const [buildersatgestatus, setBuilderSatgeStatus] = useState(0);
    const [checkstatus, setCheckStatus] = useState(false);
    const [apicallupate, setApicallupate] = useState(false);
    const [BuildStations, setBuildStations] = useState([]);
    const [PickUpStations, setPickUpStations] = useState([]);
    const [BuildStation, setBuildStation] = useState(0);
    const [selectOptionnumber, setSelectOptionnumber] = useState(0);
    const [buildstatus3, setBuildstatus3] = useState(false);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const selectOption = (option) => {
        setSelectedOption(option.text);
        setselectedOptionsId(option.number)
        setSelectOptionnumber(option.number);
    };

    const closeDropdown = () => setIsOpen(false);

    const [options, setOptions] = useState([
        { text: 'Assigned', color: 'orange', number: "501" },
        { text: 'Building', color: 'yellow', number: '502' },
        { text: 'Complete', color: 'green', number: '503' },
        { text: 'Verified', color: 'blue', number: '504' }
    ]);

    const PicupStations = [
        {
            id: 1,
            Pickup_Stations_name: "Pick Up Station",
        },
        {
            id: 2,
            Pickup_Stations_name: "Pick Up Station",
        },
        {
            id: 3,
            Pickup_Stations_name: "Pick Up Station",
        },

    ]


    const goBack = () => {
        history.goBack();
    };

    const [scrolled, setScrolled] = React.useState(false);


    const [allmodels, setAllModels] = useState([]);

    const getRemortFittingDataById = () => {
        getremoteInquirydataApi({ id: id }).then((res) => {
            console.log("call api", "1");
            if (res?.code === 200) {
                const userData = res.data.data;
                setDeliveryType(res.data.data.delivery_type)
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const getallModels = () => {
        getallModeldatabymake().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setAllModels(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        getbuildSheetDataById();
        getDataById();
        getallModels();
        getRemortFittingDataById();
        buildStGets();

        dropdownfilter().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setBuildStations(data);
            }
        }).catch((err) => {
            console.log(err);
        });

        pickUpdownfilter().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setPickUpStations(data);
            }
        }).catch((err) => {
            console.log(err);
        });


        const getCurrentUserdata = getCurrentUser();
        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const getDataById = () => {
        setIsLoading(true);
        // getsinglebuilstation({ project_id: id }).then((res) => {
        //     if (res?.code === 200) {
        //         const Data = res.data.data;
        //         console.log("Data", Data);
        //         setBuildSheetNumber(Data);
        //         if (Data.shipping_station_Id === "501") {
        //             setSelectedOption("Assigned");
        //         }
        //         if (Data.shipping_station_Id === '502') {
        //             setSelectedOption("Building");
        //         }
        //         if (Data.shipping_station_Id === '503') {
        //             setSelectedOption("Complete");

        //         }
        //         if (Data.shipping_station_Id !== '501' && Data.shipping_station_Id !== '502' && Data.shipping_station_Id !== '503') {
        //             setSelectedOption("Verified");
        //             setCheckStatus(true);
        //         }
        //     } else {
        //         alert(res.data?.message);
        //     }
        // }).catch((err) => {
        //     alert(err);
        // }).finally(() => {
        //     setIsLoading(false);
        // });

        getsinglebuildStations({ project_id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildStation(Data);
                setBuildSheetNumber(Data);
                setSelectedOption(Data.shipping_station_name);
                setselectedOptionsId(Data.shipping_station_Id);
                setselectedOptionsIdFromBd(Data.shipping_station_Id);
                if (Data.shipping_station_Id == '501' || Data.shipping_station_Id == '502' || Data.shipping_station_Id == '503' || Data.shipping_station_Id == '504') {
                    setBuildstatus3(false);
                } else {
                    setBuildstatus3(true);
                }
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const getbuildSheetDataById = () => {
        getbuildsheetdata({ id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildSheetData(Data);
            } else {
                // alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
        if (buildApiCall !== 0) {
            getbuildSheetDataById();
        }
    }, [buildApiCall])


    const handleupatestatus = () => {
        setApicallupate(true);
        upatebuildStationbuilderSatgeStatus({ _id: buildsheetnumber._id, shipping_station_Id: buildersatgestatus, shipping_station_name: selectedOption }).then((res) => {
            if (res?.code === 200) {
                closeDropdown();
                getDataById();
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setApicallupate(false);
        });
    }

    const closeButton = () => {
        setShowinsight(false);
    }


    const [buildsts, setbuildsts] = useState();

    const buildStGets = () => {
        ShippingStGet()
            .then((res) => {
                const Data = res.data.data;
                setbuildsts(Data)
            })
            .catch((err) => {
                alert(err);
            });
    }


    useEffect(() => {
        if (BuildStations && Array.isArray(buildsts) && buildsts.length > 0 && PickUpStations && Array.isArray(PickUpStations)) {
            if (deliveryType === 2) {
                const stationStatusArray = BuildStations.map(build => Number(build.station_Id));

                const filteredStatusDropdown = buildsts.filter(
                    station => !stationStatusArray.includes(Number(station.Shipping_Stations_id))
                );
                const newOptions = filteredStatusDropdown.map(station => ({
                    text: station.Shipping_Stations_name,
                    number: Number(station.Shipping_Stations_id),
                    color: 'white'
                }));

                setOptions(prevOptions => [
                    { text: 'Assigned', color: 'orange', number: "501" },
                    { text: 'Building', color: 'yellow', number: '502' },
                    { text: 'Complete', color: 'green', number: '503' },
                    { text: 'Verified', color: 'blue', number: '504' },
                    ...newOptions
                ]);
            }
            else if (deliveryType === 1) {
                const stationStatusArray = PickUpStations.map(build => Number(build.station_Id));
                const filteredStatusDropdown = PicupStations.filter(
                    station => !stationStatusArray.includes(Number(station.id))
                );

                const newOptions = filteredStatusDropdown.map(station => ({
                    text: station.Pickup_Stations_name,
                    number: Number(station.id),
                    color: 'white'
                }));

                setOptions(prevOptions => [
                    { text: 'Assigned', color: 'orange', number: "501" },
                    { text: 'Building', color: 'yellow', number: '502' },
                    { text: 'Complete', color: 'green', number: '503' },
                    { text: 'Verified', color: 'blue', number: '504' },
                    ...newOptions
                ]);
            } else {
                const stationStatusArray = BuildStations.map(build => Number(build.station_Id));

                const filteredStatusDropdown = buildsts.filter(
                    station => !stationStatusArray.includes(Number(station.Shipping_Stations_id))
                );
                const newOptions = filteredStatusDropdown.map(station => ({
                    text: station.Shipping_Stations_name,
                    number: Number(station.Shipping_Stations_id),
                    color: 'white'
                }));

                setOptions(prevOptions => [
                    { text: 'Assigned', color: 'orange', number: "501" },
                    { text: 'Building', color: 'yellow', number: '502' },
                    { text: 'Complete', color: 'green', number: '503' },
                    { text: 'Verified', color: 'blue', number: '504' },
                    ...newOptions
                ]);
            }
        }
    }, [buildsts, BuildStations, deliveryType, PickUpStations]);

    const getColorClass = () => {
        const selectedColor = options.find(opt => opt.text === selectedOption)?.color;
        return selectedColor ? `${selectedColor}` : 'white';
    };

    const [apicallupateNew, setApicallUpateew] = useState(false);


    const handleassignpickupstation = () => {
        setApicallUpateew(true);
        const data = {
            'status': (selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504') ? '0' : '1',
            'id': BuildStation._id,
            'project_id': params.id,
            "user_id": userdata._id,
            "fitter_name": userdata.firstname + " " + userdata.lastname,
            "shipping_station_Id": selectedOptionsId,
            "shipping_station_name": selectedOption,
        }
        assignpickupstation(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                alert(res.data.data[0].detail);
            } else {
                setApicallUpateew(false);
                getDataById();
                closeDropdown();
                // window.location.reload();
                if (selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504') {
                    window.location.reload();
                } else {
                    window.location.href = `/builder-dashboard`
                }
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    const handleupateprojectstatus = () => {
        setApicallUpateew(true);
        const data = {
            'status': (selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504') ? '0' : '1',
            'id': BuildStation._id,
            'project_id': params.id,
            "user_id": userdata._id,
            "fitter_name": userdata.firstname + " " + userdata.lastname,
            "shipping_station_Id": selectedOptionsId,
            "shipping_station_name": selectedOption,
        }
        upatebuildStationStatus(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                alert(res.data.data[0].detail);
            } else {
                setApicallUpateew(false);
                getDataById();
                closeDropdown();
                // window.location.reload();
                if (selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504') {
                    window.location.reload();
                } else {
                    window.location.href = `/builder-dashboard`
                }
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }
    return (
        <>
            {
                isLoading ? (
                    <div className="loading">
                        <Loader2 />
                    </div>
                ) : (
                    <>
                        <div className="main-page-body-content-header">
                            <HeaderAdmin />
                        </div>

                        {
                            showinsight === true ? (
                                <>
                                    <BuildsheetInsights id={id} closeButton={closeButton} />
                                </>
                            ) : (
                                <>

                                    <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec inline-btn-dashboard">
                                        <div className="main-container">
                                            <div className="main-page-body-content">
                                                <div className="main-page-body-content-body">
                                                    <div className="main-page-body-content-body-container">
                                                        <div className="container-fluid">
                                                            <div className="sec-header-new">
                                                                <button type="button" className="btn-header-transparent">
                                                                    <div className="border_box_view">
                                                                        <div className="border_box_view_inner">
                                                                            <div className="box_icon">
                                                                                <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd"><path d="m15.2752 2c-4.0003 0-7.61569 2.38397-9.19148 6.06081l-4.08372 9.52869v24.4105c0 6.6274 5.37258 12 12 12h14.7613c-1.1303-2.4315-1.7613-5.142-1.7613-8 0-10.4934 8.5066-19 19-19 2.858 0 5.5685.631 8 1.7613v-11.1718l-4.0837-9.52869c-1.5758-3.67684-5.1912-6.06081-9.1915-6.06081zm-5.5149 7.63648c.9455-2.2061 3.1147-3.63648 5.5149-3.63648h10.7248v10h-18.96692zm20.2397 6.36352v-10h10.7248c2.4002 0 4.5694 1.43038 5.5149 3.63649l2.7272 6.36351zm-13 25c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-5c-1.1046 0-2-.8954-2-2s.8954-2 2-2z" /><path d="m30 46c0-8.8366 7.1634-16 16-16s16 7.1634 16 16-7.1634 16-16 16-16-7.1634-16-16zm24 0c0 1.1046-.8954 2-2 2h-4v4c0 1.1046-.8954 2-2 2s-2-.8954-2-2v-4h-4c-1.1046 0-2-.8954-2-2s.8954-2 2-2h4v-4c0-1.1046.8954-2 2-2s2 .8954 2 2v4h4c1.1046 0 2 .8954 2 2z" /></g></svg>
                                                                            </div>
                                                                            <div className="box_text_content">
                                                                                {/* <div className="big_text">Build Station {getbuildStationNumber(BuildStation.station_name)}</div> */}
                                                                                <div className="big_text">Build Station {buildsheetnumber?.station_Id}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </button>
                                                                <div className="header-left">

                                                                    <button type="button" className="btn-header-transparent me-3" onClick={() => {
                                                                        setShowinsight(true);
                                                                    }}>
                                                                        <div className="border_box_view">
                                                                            <div className="border_box_view_inner">
                                                                                <div className="box_icon">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" fill='#99ea24'><path d="m141 201h110v30h-110z" /><path d="m281 321h30v30h-30z" /><path d="m281 381h30v30h-30z" /><path d="m141 261h110v30h-110z" /><path d="m141 381h110v30h-110z" /><path d="m281 261h30v30h-30z" /><path d="m141 321h110v30h-110z" /><path d="m341 261h30v30h-30z" /><path d="m341 201h30v30h-30z" /><path d="m341 381h30v30h-30z" /><path d="m341 321h30v30h-30z" /><path d="m281 201h30v30h-30z" /><path d="m351 8.783v91.217h91.211z" /><path d="m336 130c-8.284 0-15-6.716-15-15v-115h-215c-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h300c24.813 0 45-20.187 45-45v-337zm65 296c0 8.284-6.716 15-15 15h-260c-8.284 0-15-6.716-15-15v-240c0-8.284 6.716-15 15-15h260c8.284 0 15 6.716 15 15z" /></svg>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </button>

                                                                    <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                                        <div className="border_box_view">
                                                                            <div className="border_box_view_inner">
                                                                                <div className="box_icon">
                                                                                    <IoCloseSharp />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="dashboard-sec">
                                                                <div className="row">
                                                                    <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open db_col">
                                                                        <div className="build_number_box">
                                                                            <div className="build_number_box_inner">
                                                                                <div className="build_title">
                                                                                    Build Station
                                                                                </div>
                                                                                <div className="build_number">
                                                                                    {buildsheetnumber?.station_Id || 0}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <BuildAccordion buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} allmodels={allmodels} />
                                                                    </div>
                                                                    <div className={`col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec ${scrolled ? 'tab_fix' : ''}`}>
                                                                        <div className="fix_sec_view container-fluid ps-0">
                                                                            {/* <div className='select-dropdown-build mt-0'>
                                                                                <div className={`select-options-dropdown ${isOpen ? 'open' : ''}`}> 
                                                                                    <div className='select-option-inner' onClick={!checkstatus ? toggleDropdown : null}>
                                                                                        <div className='select-options-icon'>
                                                                                            <span className={`icon-color color-${options.find(opt => opt.text === selectedOption).color}`}></span>
                                                                                        </div>
                                                                                        <div className='selected-option-text'>{selectedOption}</div>
                                                                                        <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                                                                            <i className="bi bi-chevron-down" />
                                                                                        </span>
                                                                                    </div>

                                                                                    {isOpen && (
                                                                                        <div className='option-list buildsheet-option-list'>
                                                                                            <div className='drop-down-list'> 
                                                                                                {options
                                                                                                    .filter(option => option.text !== 'Verified')
                                                                                                    .map(option => (
                                                                                                        <div
                                                                                                            key={option.text}
                                                                                                            className={`drop-down-item ${selectedOption === option.text ? 'active' : ''}`}
                                                                                                            onClick={() => selectOption(option)}
                                                                                                        >
                                                                                                            <div className='drop-down-item-icon'>
                                                                                                                <span className={`icon-color color-${option.color}`}></span>
                                                                                                            </div>
                                                                                                            <div className='drop-down-item-text'>{option.text}</div>
                                                                                                        </div>
                                                                                                    ))
                                                                                                }
                                                                                            </div>
                                                                                            <div className='form-box-section'>
                                                                                                {
                                                                                                    selectedOption == 'Assigned' || selectedOption === 'Verified' ? (
                                                                                                        <button
                                                                                                            className="btn btn-primary btn-create"
                                                                                                            disabled
                                                                                                        >
                                                                                                            <span>Update Status</span>

                                                                                                        </button>
                                                                                                    ) : (
                                                                                                        <button
                                                                                                            className="btn btn-primary btn-create"
                                                                                                            // onClick={closeDropdown2}
                                                                                                            onClick={() => {
                                                                                                                handleupatestatus();
                                                                                                            }}
                                                                                                        >
                                                                                                            {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                                        </button>
                                                                                                    )
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div> */}

                                                                            {
                                                                                deliveryType === 1 && <>
                                                                                    <div className='select-dropdown-build'>
                                                                                        <div className={`select-options-dropdown ${isOpen ? 'open' : ''}`}>
                                                                                            <div className='select-option-inner' onClick={!buildstatus3 ? toggleDropdown : null}>
                                                                                                <div className='select-options-icon'>
                                                                                                    <span className={`icon-color color-${getColorClass()}`}>{selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504' ? '' : selectedOptionsId}</span>
                                                                                                </div>
                                                                                                <div className='selected-option-text'>{selectedOption}</div>
                                                                                                <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                                                                                    <i className="bi bi-chevron-down" />
                                                                                                </span>
                                                                                            </div>

                                                                                            {isOpen && (
                                                                                                <div className='option-list buildsheet-option-list'>
                                                                                                    <div className='drop-down-list'>
                                                                                                        {options.map(option => (
                                                                                                            <div
                                                                                                                key={option.number}
                                                                                                                className={`drop-down-item ${selectOptionnumber === option.number ? 'active' : ''}`}
                                                                                                                style={{
                                                                                                                    pointerEvents:
                                                                                                                        selectedOptionsIdFromBd !== "504" && typeof option.number === "number"
                                                                                                                            ? "none"
                                                                                                                            : "auto",
                                                                                                                    opacity:
                                                                                                                        selectedOptionsIdFromBd !== "504" && typeof option.number === "number"
                                                                                                                            ? 0.5
                                                                                                                            : 1,
                                                                                                                }}
                                                                                                                onClick={() => selectOption(option)}
                                                                                                            >
                                                                                                                <div className='drop-down-item-icon'>
                                                                                                                    <span className={`icon-color color-${option.color}`}>{option.number == '501' || option.number == '502' || option.number == '503' || option.number == '504' ? '' : option.number}</span>
                                                                                                                </div>
                                                                                                                <div className='drop-down-item-text'>{option.text}</div>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                    <div className='form-box-section'>
                                                                                                        {
                                                                                                            selectedOptionsId == '501' ? (
                                                                                                                <button
                                                                                                                    className="btn btn-primary btn-create"
                                                                                                                    disabled
                                                                                                                >
                                                                                                                    <span>Update Status</span>

                                                                                                                </button>
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    {
                                                                                                                        apicallupateNew ? (<button
                                                                                                                            className="btn btn-primary btn-create"
                                                                                                                            disabled
                                                                                                                        >
                                                                                                                            Updating..

                                                                                                                        </button>) : (<button
                                                                                                                            className="btn btn-primary btn-create"
                                                                                                                            // onClick={closeDropdown}
                                                                                                                            onClick={() => {
                                                                                                                                // closeDropdown()
                                                                                                                                handleassignpickupstation();
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}

                                                                                                                        </button>)
                                                                                                                    }
                                                                                                                </>
                                                                                                            )
                                                                                                        }

                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            }

                                                                            {
                                                                                deliveryType !== 1 && <>
                                                                                    <div className='select-dropdown-build'>
                                                                                        <div className={`select-options-dropdown ${isOpen ? 'open' : ''}`}>
                                                                                            <div className='select-option-inner' onClick={!buildstatus3 ? toggleDropdown : null}>
                                                                                                <div className='select-options-icon'>
                                                                                                    <span className={`icon-color color-${getColorClass()}`}>{selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504' ? '' : selectedOptionsId}</span>
                                                                                                </div>
                                                                                                <div className='selected-option-text'>{selectedOption}</div>
                                                                                                <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                                                                                    <i className="bi bi-chevron-down" />
                                                                                                </span>
                                                                                            </div>

                                                                                            {isOpen && (
                                                                                                <div className='option-list buildsheet-option-list'>
                                                                                                    <div className='drop-down-list'>
                                                                                                        {options.map(option => (
                                                                                                            <div
                                                                                                                key={option.number}
                                                                                                                className={`drop-down-item ${selectOptionnumber === option.number ? 'active' : ''}`}
                                                                                                                style={{
                                                                                                                    pointerEvents:
                                                                                                                        selectedOptionsIdFromBd !== "504" && typeof option.number === "number"
                                                                                                                            ? "none"
                                                                                                                            : "auto",
                                                                                                                    opacity:
                                                                                                                        selectedOptionsIdFromBd !== "504" && typeof option.number === "number"
                                                                                                                            ? 0.5
                                                                                                                            : 1,
                                                                                                                }}
                                                                                                                onClick={() => selectOption(option)}
                                                                                                            >
                                                                                                                <div className='drop-down-item-icon'>
                                                                                                                    <span className={`icon-color color-${option.color}`}>{option.number == '501' || option.number == '502' || option.number == '503' || option.number == '504' ? '' : option.number}</span>
                                                                                                                </div>
                                                                                                                <div className='drop-down-item-text'>{option.text}</div>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                    <div className='form-box-section'>
                                                                                                        {
                                                                                                            selectedOptionsId == '501' ? (
                                                                                                                <button
                                                                                                                    className="btn btn-primary btn-create"
                                                                                                                    disabled
                                                                                                                >
                                                                                                                    <span>Update Status</span>

                                                                                                                </button>
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    {
                                                                                                                        apicallupateNew ? <button
                                                                                                                            className="btn btn-primary btn-create"
                                                                                                                            disabled
                                                                                                                        >
                                                                                                                            Updating...
                                                                                                                        </button> : (<button
                                                                                                                            className="btn btn-primary btn-create"
                                                                                                                            // onClick={closeDropdown}
                                                                                                                            onClick={() => {
                                                                                                                                // closeDropdown()
                                                                                                                                handleupateprojectstatus();
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            Update Status

                                                                                                                        </button>)
                                                                                                                    }
                                                                                                                </>

                                                                                                            )
                                                                                                        }

                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div></>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    </>
                )
            }
        </>
    );
}

export default BuilderProjectView;